<template>
  <div class="apphome_box">
    <span style="font-size: 16px;font-weight: bold;transform: translateY(-10px);
    display: block;">虚拟设备</span>
    <span class="search">
      <span style="display: flex;white-space: nowrap;align-items: center;">
        <span>标题：</span>
        <el-input v-model="conditions.Name" style="width: 120px;" placeholder="请输入标题" clearable></el-input>
      </span>
      <el-button type="primary" icon="el-icon-search" @click="getList" :loading="loading">查询</el-button>
      <el-button @click="dialogTableVisible=true" style="margin-right: 20px;">绑定</el-button>

    </span>
    <el-table id="demo" :max-height="heights-257" ref="multipleTable" @select="handleSelectionChange"
      @select-all='handleSelectionChange'
      :header-cell-style="{ color: '#333', fontFamily: 'MicrosoftYaHeiUI', fontSize: '14px', fontWeight: 900, backgroundColor: '#f5f7fa'}"
      stripe :data="list" border style="width: 100%">
      <template slot="empty">
        <span class="noData">
          <img src="../../assets/noData.png" alt="暂无数据">
          <span class="text">暂无数据</span>
        </span>
      </template>
      <el-table-column type="selection" width="39">
      </el-table-column>
      <el-table-column label="序号" width="90" align="center">
        <template slot-scope="scope">
          <span>{{ scope.$index + 1 }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="Name" label="名称" align="center"> </el-table-column>
      <el-table-column prop="VirtaulDeviceNo" label="绑定编号" align="center"> </el-table-column>
    </el-table>
    <span class="paginationed">
      <Pagination align="center" :total="total" layout="prev, pager, next" :pager-count="5" :page.sync="listData.page"
        :limit.sync="listData.rows" @pagination="getList" />
    </span>

    <el-dialog v-dialogDrag title="绑定列表" :visible.sync="dialogTableVisible" center>
      <el-form label-width="80px">
        <el-form-item label="已绑定">
          <el-tag v-for="(item,index) in optionsd" closable :key="index" style="margin-right: 10px;"
            @close="handleClose2(optionsd,index)">{{item.Name}}</el-tag>
        </el-form-item>
        <el-form-item label="已选中">
          <span v-for="(item,index) in toggleRowData" :key="index" class="spaned">
            第{{index+1}}页：
            <el-tag v-for="(i,e) in item" :key='e' closable style="margin-right: 10px;" @close="handleClose(index,e)">
              {{i.Name}}</el-tag>
          </span>
        </el-form-item>
      </el-form>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="dialogTableVisible =false">取消</el-button>
          <el-button type="primary" @click="saveDevice(1)">绑定
          </el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>
<script>
  //   import { GetEnergyBuildingVirtualDevices, SaveEnergyBuildingDevices } from "@/utils/javaRequest";
  import {isEmpty} from "@/utils/tools"
  //   import request from "@/utils/request";
  //   import { parseTime } from "@/utils";
  import Pagination from "../../components/module/Pagination"; // 分页
  export default {
    components: {Pagination},
    props: ["mainId"],
    data () {
      return {
        optionsd: [],//已绑定数据
        dialogTableVisible: false,
        toggleRowData: [],
        defaultProps: {
          children: 'children',
          label: 'label'
        },
        loading: false,
        conditions: {Name: ''},
        total: 0,
        list: [],
        temp: {},
        textMap: {
          add: "新增",
          edit: "编辑"
        },
        heights: document.body.clientHeight-18,
        dialogVisible: false,
        rules: {
          UpId: [
            {required: true,message: '请输入父id',trigger: 'blur'}
          ],
          Name: [
            {required: true,message: '请输入区域名称',trigger: 'blur'}
          ],
          Code: [
            {required: true,message: '请输入区域编码',trigger: 'blur'}
          ],
          Type: [
            {required: true,message: '请选择路由',trigger: 'change'}
          ],

        },

        listData: {
          "page": 1,
          "rows": 10,
        },
      };
    },
    computed: {
      nowUnit: function() {
        return this.$store.state.settings.count;
      }
    },
    mounted () {
      var d=setInterval(() => {
        if(this.mainId) {
          this.getList();//获取列表数据
          clearInterval(d);
        }
      },1000);


    },
    methods: {

      handleClose (i,e) {
        this.toggleRowData[i].splice(e,1);
        this.toggleRowData=this.toggleRowData;
      },
      handleClose2 (i,e) {
        i.splice(e,1);
      },
      childMethod (v) {
        this.toggleRowData=[];
        this.mainId=v;
        this.getList();
      },
      // 绑定
      saveDevice (v) {
        var d={
          "mainId": this.mainId,
          "selectOptions": []
        };
        this.toggleRowData.map(v => {
          v.map(a => {
            d.selectOptions.push(a.VirtaulDeviceNo)
          })
        })

        //添加绑定
        // if (v) {
        //   this.optionsd.map(e=>{
        //     d.selectOptions.push(e.Id);
        //   })
        // }

        d.selectOptions=Array.from(new Set(d.selectOptions));
        this.dialogTableVisible=false;

        //   SaveEnergyBuildingDevices(d).then(res => {
        //     if(res.success && !isEmpty(res.data)) {
        //           this.toggleRowData = [];
        //           this.getList();
        //           this.$message({
        //             showClose: true,
        //             message: "保存成功",
        //             type: 'success',
        //             duration: 5 * 1000
        //           })
        //     }
        //   })

      },
      // 获取绑定列表
      getList (v) {

        let d={
          "buildingId": this.mainId,
          "pageIndex": this.listData.page,
          "pageSize": this.listData.rows,
          "unitId": this.nowUnit,
          "name": this.conditions.Name
        }
        this.loading=true;
        //    GetEnergyBuildingVirtualDevices(d).then(res => {
        //       this.loading=false;
        //       this.list = res.data.PageData.data;
        //       this.total = res.data.PageData.dataCount;
        //        this.optionsd = res.data.MultipleSelectOption.SelectOptions;
        //      setTimeout(() => {
        //       this.optionsd.map(v => {
        //         this.list.map((a, i) => {
        //           if (a.VirtaulDeviceNo == v.Id) {
        //             this.$refs.multipleTable.toggleRowSelection(this.list[i],true);
        //           }
        //         })
        //       })
        //      }, 100);
        //       //每页勾选
        //       if (this.toggleRowData[this.listData.page - 1]) {
        //         setTimeout(() => {
        //           this.toggleRowData[this.listData.page - 1].map(v => {
        //             this.list.map((a, i) => {
        //               if (a.VirtaulDeviceNo == v.VirtaulDeviceNo) {
        //                 this.$refs.multipleTable.toggleRowSelection(this.list[i],true);
        //               }
        //             })
        //           })
        //         }, 100);
        //       }
        //     })
      },
      // 勾选
      handleSelectionChange (val) {
        this.toggleRowData[this.listData.page-1]=val;
      },


      //先根据id和parentId的关系生成关系树
      makeTree (arr,Id) {
        var temp=[];
        for(var i=0;i<arr.length;i++) {
          //如果某个元素的parentId和传入的pid相等，作为pid对应id对象的children集合中的数据
          if(arr[i].UpId==Id||arr[i].ParentId==Id) {
            temp.push(arr[i]);
            //再递归的生成关系树
            arr[i].children=this.makeTree(arr,arr[i].Id);
          }
        }
        return temp;
      },


    }
  };
</script>
<style lang="scss">
  .select_tree {
    .el-tree-node {
      .is-leaf+.el-checkbox .el-checkbox__inner {
        display: inline-block;
      }

      .el-checkbox__input>.el-checkbox__inner {
        display: none;
      }
    }

  }
</style>
<style lang="scss" scoped>
  .spaned {
    display: flex;
    flex-wrap: wrap;
  }

  .band {
    color: red;
    padding-left: 20px;
    font-size: 12px;
    margin-bottom: 5px;
  }

  .search {
    margin-bottom: 12px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .avatar {
    width: 30px;
    height: 30px;
    object-fit: cover;
  }

  .el-icon-d-arrow-left {
    position: absolute;
    right: 0;
    top: 300px;
    z-index: 1;
    font-size: 28px;
    cursor: pointer;
    background: #d7d7d7;
    clip-path: polygon(-18px 35px,
        26px 100%,
        calc(100% - 1px) 100%,
        calc(100% - 0px) 0);
    height: 70px;
    line-height: 70px;
    color: #666;
  }

  .el-icon-d-arrow-right {
    position: absolute;
    left: 0;
    top: 300px;
    z-index: 1;
    font-size: 28px;
    cursor: pointer;
    background: #d7d7d7;
    clip-path: polygon(0 0,
        1px 100%,
        calc(100% - 26px) 100%,
        calc(100% - -27px) 31px);
    height: 70px;
    line-height: 70px;
    color: #666;
  }

  .wrapper {
    width: 100%;
    height: 500px;
  }

  .pagination_box {
    display: flex;
    justify-content: flex-end;
    margin-top: 5px;
  }
</style>